const LoaderOverlay = () => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
      <div className="w-24 h-24 border-4 border-t-transparent rounded-full animate-spin loader-spinner"></div>
    </div>
  );
};

export default LoaderOverlay;
